module.exports = __webpack_public_path__ + "media/nachtigall.f3c3b54b.mp3";